import type { T_Maybe } from '@tryiris-ai/js-types';
import { createContext } from 'react';
import type { Store } from './types.js';

/** Store context. */
export const Context = createContext<T_Maybe<Store>>(undefined);
